import { observer } from "mobx-react-lite";

import "./Metric.css";

function Metric({ label, value, unit, color, fontSize = "2em" }) {
  return (
    <>
      <div className="Metric">
        <div className="Metric__label">{label}</div>
        <div
          style={{ fontSize: fontSize }}
          className={`Metric__value ${color}`}
        >
          {value}
        </div>
        <div className="Metric__unit">{value && unit}</div>
      </div>
    </>
  );
}

export default observer(Metric);
